import React from 'react';

const Logo = (props) => {
  return (
    <img src="/static/images/logo.png" alt="Open Outcomes" style={{height:null,flex:1,width:200}}/>              
  );
};

export default Logo;
